var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuDispositivi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-dispositivi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-dispositivi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001132,24 C18.6274602,24 24,18.6272846 24,12 C24,5.37271544 18.6274602,0 12.0001132,0 C5.37253977,0 0,5.37271544 0,12 C0,18.6272846 5.37253977,24 12.0001132,24 Z",
    id: "Fill-1",
    fill: "#009846"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDispositivi);
export default __webpack_public_path__ + "static/media/menu-dispositivi.5d9bda56c42df379bb53a2d28bec3022.svg";
export { ForwardRef as ReactComponent };